const AssessmentDetails = ({ currentQuizTest, level, description, stats }) => {
  return (
    <>
      <div className="row mb-5 mx-0">
        <div className="col-lg-8 mx-auto text-center">
          <div className="mt-2 mb-3">
            {currentQuizTest?.quizTechnology && (
              <span className="badge rounded-pill px-4 py-2 me-2 fs-5 bg-gradient-primary">
                {currentQuizTest.quizTechnology}
              </span>
            )}
            {level && (
              <span className="badge rounded-pill px-4 py-2 bg-success fs-5">
                {level}
              </span>
            )}
          </div>

          <h1 className="display-4 fw-bold text-white mb-3 mt-0 pt-3">
            {currentQuizTest?.quizTitle || "Quiz Title Unavailable"}
          </h1>

          <p className="lead text-white opacity-75 mb-4">
            {description || "No description available for this quiz."}
          </p>

          <div className="row justify-content-center text-center mb-4">
            <div className="col-md-2 col-4 mb-3">
              <div className="h4 fw-bold text-white">⏱️</div>
              <div className="text-white">
                {currentQuizTest?.duration ? `${currentQuizTest.duration} minutes` : "N/A"}
              </div>
            </div>

            <div className="col-md-2 col-4 mb-3">
              <div className="h4 fw-bold text-white">❓</div>
              <div className="text-white">
                {currentQuizTest?.quizQuestions?.length ?? 0} Questions
              </div>
            </div>

            <div className="col-md-2 col-4 mb-3">
              <div className="h4 fw-bold text-white">🎯</div>
              <div className="text-white">
                {currentQuizTest.quizTechnology}
              </div>
            </div>

            {/* <div className="col-md-2 col-4 mb-3">
              <div className="h4 fw-bold text-white">🔄</div>
              <div className="text-white">
                {stats?.attemptsAllowed ?? "N/A"} Attempts
              </div>
            </div> */}

            <div className="col-md-2 col-4 mb-3">
              <div className="h4 fw-bold text-white">⭐</div>
              <div className="text-white">
                {stats?.rating ?? "N/A"} Rating
              </div>
            </div>

            <div className="col-md-2 col-4 mb-3">
              <div className="h4 fw-bold text-white">👥</div>
              <div className="text-white">
                {currentQuizTest.completedBy?.length ?? 0} Students
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AssessmentDetails;